export default String.raw`
<g id="Polecane homepage/desktop">
    <rect width="1440" height="581" class="bgColor"/>
    <g id="header_newSections">
        <text class="primaryColorFont" xml:space="preserve" style="white-space: pre" font-size="24" font-weight="500" letter-spacing="0px"><tspan x="130" y="56.7273">RECOMMENDEDTYPE_LABEL</tspan></text>
        <g id="4. Text Button" class="iconColors">
            <text id="Text" xml:space="preserve" style="white-space: pre" font-size="14" font-weight="600" letter-spacing="0px"><tspan x="1172.29" y="53.0909">TRANSLATION_Prv_ShowAll</tspan></text>
            <g id="Arrows/chevron right">
                <use transform="translate(1290, 40)" href="#chevron-right" width="16" height="16"></use>
            </g>
        </g>
    </g>
    <g id="Kafelki">
        <g id="Kafelek produktu">
            <g id="Frame 179">
                <rect x="138" y="88" width="269" height="269" fill="white"/>
                <image preserveAspectRatio="xMidYMid meet" width="269" height="269" x="138" y="88" xlink:href="./img/previewElements/newsSection_1.png" />
            </g>
            <g id="Frame 182">
                <text class="primaryColorFont" xml:space="preserve" style="white-space: pre" font-size="14" letter-spacing="0px"><tspan x="138" y="388.091">TRANSLATION_Prv_PromoBanner_KeyboardHyperRun</tspan></text>
                <g id="Cena">
                    <g id="Cena podstawowa">
                        <text class="primaryColorFont" xml:space="preserve" style="white-space: pre" font-size="14" font-weight="600" letter-spacing="0px"><tspan x="138" y="424.091">310,67 z&#x142;</tspan></text>
                        <text class="bgColorFont" xml:space="preserve" style="white-space: pre" font-size="12" letter-spacing="0px" text-decoration="line-through"><tspan x="207" y="423.364">390,67 z&#x142;</tspan></text>
                        <text class="primaryColorFont" xml:space="preserve" style="white-space: pre" font-size="14" letter-spacing="0px"><tspan x="268" y="424.091">netto</tspan></text>
                    </g>
                    <g id="Frame 883">
                        <text class="bgColorFont" xml:space="preserve" style="white-space: pre" font-size="12" letter-spacing="0px"><tspan x="138" y="449.364">390,67 z&#x142; brutto - najni&#x17c;sza cena z 30 dni</tspan></text>
                    </g>
                </g>
            </g>
            <g id="Label">
                <rect x="134" y="100" height="17" rx="2" RECOMMENDEDTYPE_FLAGSTYLE class="RECOMMENDEDTYPE_FLAGCOLOR" />
                <text class="ribbonTextColor" xml:space="preserve" style="white-space: pre" font-size="10" font-weight="500" letter-spacing="0px"><tspan x="142.262" y="112.136">RECOMMENDEDTYPE_FLAGTEXT</tspan></text>
            </g>
            <g id="Button do koszyka">
                <g id="Primary button">
                    <rect x="138" y="469" width="221" height="40" rx="5" class="btnSolidBgColor"/>
                    <foreignObject x="138" y="469" width="185" height="40">
                        <div xmlns="http://www.w3.org/1999/xhtml" style="height: 100%; display: flex; align-items: center; justify-content: center; padding-left: 15px;">
                            <span class="btnSolidTextColor" style="font-size: 14px; font-weight: 600; line-height: 1.2;">TRANSLATION_Prv_AddToCart</span>
                        </div>
                    </foreignObject>
                    <g id="Interface/Cart 1">
                        <use class="btnSolidTextColor" transform="translate(327, 477)" href="#shopping-cart" width="24" height="24"></use>
                    </g>
                </g>
                <g id="Add to favourite">
                    <rect x="368" y="470" width="38" height="38" rx="4" class="secondaryBtnBgColor secondaryBtnBorderColor--stroke" stroke-width="2"/>
                    <g id="Interface/clipboard">
                        <use class="secondaryBtnFontColor" transform="translate(375, 477)" href="#clipboard-list" width="24" height="24"></use>
                    </g>
                </g>
            </g>
        </g>
        <g id="Kafelek produktu_2">
            <g id="Frame 179_2">
                <rect x="439" y="88" width="269" height="269" fill="white"/>
                <image preserveAspectRatio="xMidYMid meet" width="269" height="269" x="439" y="88" xlink:href="./img/previewElements/newsSection_2.png" />
            </g>
            <g id="Frame 182_2">
                <text class="primaryColorFont" xml:space="preserve" style="white-space: pre" font-size="14" letter-spacing="0px"><tspan x="439" y="388.091">TRANSLATION_Prv_PromoBanner_ProcessorTechSpeedUltra230V</tspan></text>
                <g id="Cena_2">
                    <g id="Cena podstawowa_2">
                        <text class="primaryColorFont" xml:space="preserve" style="white-space: pre" font-size="14" font-weight="600" letter-spacing="0px"><tspan x="439" y="424.091">310,67 z&#x142;</tspan></text>
                        <text class="bgColorFont" xml:space="preserve" style="white-space: pre" font-size="12" letter-spacing="0px" text-decoration="line-through"><tspan x="508" y="423.364">390,67 z&#x142;</tspan></text>
                        <text class="primaryColorFont" xml:space="preserve" style="white-space: pre" font-size="14" letter-spacing="0px"><tspan x="569" y="424.091">netto</tspan></text>
                    </g>
                    <g id="Frame 883_2">
                        <text class="bgColorFont" xml:space="preserve" style="white-space: pre" font-size="12" letter-spacing="0px"><tspan x="439" y="449.364">390,67 z&#x142; brutto - najni&#x17c;sza cena z 30 dni</tspan></text>
                    </g>
                </g>
            </g>
            <g id="Label_5">
                <rect x="435" y="100" height="17" rx="2" RECOMMENDEDTYPE_FLAGSTYLE class="RECOMMENDEDTYPE_FLAGCOLOR"/>
                <text class="ribbonTextColor" id="Label_6" class="" xml:space="preserve" style="white-space: pre" font-size="10" font-weight="500" letter-spacing="0px"><tspan x="443.262" y="112.136">RECOMMENDEDTYPE_FLAGTEXT</tspan></text>
            </g>
            <g id="Button do koszyka_2">
                <g id="Primary button_2">
                    <rect x="439" y="469" width="221" height="40" rx="5" class="btnSolidBgColor"/>
                    <foreignObject x="439" y="469" width="185" height="40">
                        <div xmlns="http://www.w3.org/1999/xhtml" style="height: 100%; display: flex; align-items: center; justify-content: center; padding-left: 15px;">
                            <span class="btnSolidTextColor" style="font-size: 14px; font-weight: 600; line-height: 1.2;">TRANSLATION_Prv_AddToCart</span>
                        </div>
                    </foreignObject>
                    <g id="Interface/Cart 1_2">
                        <use class="btnSolidTextColor" transform="translate(628, 477)" href="#shopping-cart" width="24" height="24"></use>
                    </g>
                </g>
                <g id="Add to favourite_2">
                    <rect x="669" y="470" width="38" height="38" rx="4" class="secondaryBtnBgColor secondaryBtnBorderColor--stroke" stroke-width="2"/>
                    <g id="Interface/clipboard_2">
                        <use class="secondaryBtnFontColor" transform="translate(676, 477)" href="#clipboard-list" width="24" height="24"></use>
                    </g>
                </g>
            </g>
        </g>
        <g id="Kafelek produktu_3">
            <g id="Frame 179_3">
                <rect x="740" y="88" width="269" height="269" fill="white"/>
                <image preserveAspectRatio="xMidYMid meet" width="269" height="269" x="740" y="88" xlink:href="./img/previewElements/newsSection_3.png" />
            </g>
            <g id="Frame 182_3">
                <text class="primaryColorFont" xml:space="preserve" style="white-space: pre" font-size="14" letter-spacing="0px"><tspan x="740" y="388.091">TRANSLATION_Prv_PromoBanner_HDD550BigMemory2TB</tspan></text>
                <g id="Cena_3">
                    <g id="Cena podstawowa_3">
                        <text class="primaryColorFont" xml:space="preserve" style="white-space: pre" font-size="14" font-weight="600" letter-spacing="0px"><tspan x="740" y="424.091">310,67 z&#x142;</tspan></text>
                        <text class="bgColorFont" xml:space="preserve" style="white-space: pre" font-size="12" letter-spacing="0px" text-decoration="line-through"><tspan x="809" y="423.364">390,67 z&#x142;</tspan></text>
                        <text class="primaryColorFont" xml:space="preserve" style="white-space: pre" font-size="14" letter-spacing="0px"><tspan x="870" y="424.091">netto</tspan></text>
                    </g>
                    <g id="Frame 883_3">
                        <text class="bgColorFont" xml:space="preserve" style="white-space: pre" font-size="12" letter-spacing="0px"><tspan x="740" y="449.364">390,67 z&#x142; brutto - najni&#x17c;sza cena z 30 dni</tspan></text>
                    </g>
                </g>
            </g>
            <g id="Label_9">
                <rect x="736" y="100" height="17" rx="2" RECOMMENDEDTYPE_FLAGSTYLE class="RECOMMENDEDTYPE_FLAGCOLOR"/>
                <text class="ribbonTextColor" xml:space="preserve" style="white-space: pre" font-size="10" font-weight="500" letter-spacing="0px"><tspan x="744.262" y="112.136">RECOMMENDEDTYPE_FLAGTEXT</tspan></text>
            </g>
            <g>
                <g id="Primary button_3">
                    <rect x="744.5" y="469.5" width="212" height="39" rx="4.5" class="btnSolidBgColor" />
                    <foreignObject x="754.5" y="469.5" width="192" height="39">
                        <div xmlns="http://www.w3.org/1999/xhtml" style="height: 100%; display: flex; align-items: center; justify-content: center;">
                            <span class="btnSolidTextColor" style="font-size: 14px; font-weight: 600; line-height: 1.2; white-space: nowrap;">TRANSLATION_Prv_InformAboutAvability</span>
                        </div>
                    </foreignObject>
                </g>
                <g id="Add to favourite_3">
                    <rect x="966" y="470" width="38" height="38" rx="4" class="secondaryBtnBgColor secondaryBtnBorderColor--stroke" stroke-width="2"/>
                    <g id="Interface/clipboard_3">
                        <use class="secondaryBtnFontColor" transform="translate(974, 477)" href="#clipboard-list" width="24" height="24"></use>
                    </g>
                </g>
            </g>
        </g>
        <g id="Kafelek produktu_4">
            <g id="Frame 179_4">
                <rect x="1041" y="88" width="269" height="269" fill="white"/>
                <image preserveAspectRatio="xMidYMid meet" width="269" height="269" x="1041" y="88" xlink:href="./img/previewElements/newsSection_4.png" />
            </g>
            <g id="Frame 182_4">
                <text class="primaryColorFont" xml:space="preserve" style="white-space: pre" font-size="14" letter-spacing="0px"><tspan x="1041" y="388.091">TRANSLATION_Prv_PromoBanner_MouseLizardG</tspan></text>
                <g id="Cena_4">
                    <g id="Cena podstawowa_4">
                        <text class="primaryColorFont" xml:space="preserve" style="white-space: pre" font-size="14" font-weight="600" letter-spacing="0px"><tspan x="1041" y="424.091">310,67 z&#x142;</tspan></text>
                        <text class="bgColorFont" xml:space="preserve" style="white-space: pre" font-size="12" letter-spacing="0px" text-decoration="line-through"><tspan x="1110" y="423.364">390,67 z&#x142;</tspan></text>
                        <text class="primaryColorFont" xml:space="preserve" style="white-space: pre" font-size="14" letter-spacing="0px"><tspan x="1171" y="424.091">netto</tspan></text>
                    </g>
                    <g id="Frame 883_4">
                        <text class="bgColorFont" xml:space="preserve" style="white-space: pre" font-size="12" letter-spacing="0px"><tspan x="1041" y="449.364">390,67 z&#x142; brutto - najni&#x17c;sza cena z 30 dni</tspan></text>
                    </g>
                </g>
            </g>
            <g id="Label_13">
                <rect x="1037" y="100" height="17" rx="2" RECOMMENDEDTYPE_FLAGSTYLE class="RECOMMENDEDTYPE_FLAGCOLOR"/>
                <text class="ribbonTextColor" xml:space="preserve" style="white-space: pre" font-size="10" font-weight="500" letter-spacing="0px"><tspan x="1045.26" y="112.136">RECOMMENDEDTYPE_FLAGTEXT</tspan></text>
            </g>
            <g id="Button do koszyka_3">
                <g id="Primary button_4">
                    <rect x="1041" y="469" width="221" height="40" rx="5" class="btnSolidBgColor"/>
                    <foreignObject x="1041" y="469" width="185" height="40">
                        <div xmlns="http://www.w3.org/1999/xhtml" style="height: 100%; display: flex; align-items: center; justify-content: center; padding-left: 15px;">
                            <span class="btnSolidTextColor" style="font-size: 14px; font-weight: 600; line-height: 1.2;">TRANSLATION_Prv_AddToCart</span>
                        </div>
                    </foreignObject>
                    <g id="Interface/Cart 1_3">
                        <use class="btnSolidTextColor" transform="translate(1230, 477)" href="#shopping-cart" width="24" height="24"></use>
                    </g>
                </g>
                <g id="Add to favourite_4">
                    <rect x="1271" y="470" width="38" height="38" rx="4" class="secondaryBtnBgColor secondaryBtnBorderColor--stroke" stroke-width="2" />
                    <g id="Interface/clipboard_4">
                        <use class="secondaryBtnFontColor" transform="translate(1278, 477)" href="#clipboard-list" width="24" height="24"></use>
                    </g>
                </g>
            </g>
        </g>
        <g id="Kafelek produktu_5">
            <g id="Frame 179_5">
                <rect x="1342" y="88" width="269" height="269" fill="white"/>
                <image preserveAspectRatio="xMidYMid meet" width="269" height="269" x="1342" y="88" xlink:href="./img/previewElements/newsSection_5.png" />
            </g>
            <g id="Frame 182_5">
                <text class="primaryColorFont" xml:space="preserve" style="white-space: pre" font-size="14" letter-spacing="0px"><tspan x="1342" y="388.091">TRANSLATION_Prv_PromoBanner_MegaThreadSuperB13Extreme</tspan></text>
                <g id="Cena_5">
                    <g id="Cena podstawowa_5">
                        <text class="primaryColorFont" xml:space="preserve" style="white-space: pre" font-size="14" font-weight="600" letter-spacing="0px"><tspan x="1342" y="424.091">310,67 z&#x142;</tspan></text>
                        <text class="bgColorFont" xml:space="preserve" style="white-space: pre" font-size="12" letter-spacing="0px" text-decoration="line-through"><tspan x="1411" y="423.364">390,67 z&#x142;</tspan></text>
                    </g>
                    <g id="Frame 883_5">
                        <text class="bgColorFont" xml:space="preserve" style="white-space: pre" font-size="12" letter-spacing="0px"><tspan x="1342" y="449.364">390,67 z&#x142; brutto - najni&#x17c;sza cena z 30 dni</tspan></text>
                    </g>
                </g>
            </g>
            <g id="Label_17">
                <rect x="1338" y="100" height="17" rx="2" RECOMMENDEDTYPE_FLAGSTYLE class="RECOMMENDEDTYPE_FLAGCOLOR"/>
                <text class="ribbonTextColor" xml:space="preserve" style="white-space: pre" font-size="10" font-weight="500" letter-spacing="0px"><tspan x="1346.26" y="112.136">RECOMMENDEDTYPE_FLAGTEXT</tspan></text>
            </g>
            <g id="Button do koszyka_4">
                <g id="Primary button_5">
                    <rect x="1342" y="469" width="221" height="40" rx="5" class="btnSolidBgColor"/>
                    <foreignObject x="1342" y="469" width="185" height="40">
                        <div xmlns="http://www.w3.org/1999/xhtml" style="height: 100%; display: flex; align-items: center; justify-content: center; padding-left: 15px;">
                            <span class="btnSolidTextColor" style="font-size: 14px; font-weight: 600; line-height: 1.2;">TRANSLATION_Prv_AddToCart</span>
                        </div>
                    </foreignObject>
                    <g id="Interface/Cart 1_4">
                        <use class="btnSolidTextColor" transform="translate(1531, 477)" href="#shopping-cart" width="24" height="24"></use>
                    </g>
                </g>
            </g>
        </g>
    </g>
    <g id="shade">
        <rect width="161" height="441" transform="translate(1279 88)" fill="url(#gradientSections)" class="bgColor--stop" fill-opacity="0.8"/>
    </g>
    <g id="Arrow" filter="url(#newsSection_filter_1_1)">
        <g>
            <g id="Arrows/chevron right_2">
                <rect x="1290" y="200" width="48" height="48" rx="4" class="secondaryBtnBgColor secondaryBtnBorderColor--stroke"/>
                <use class="secondaryBtnFontColor" transform="translate(1305, 216)" href="#chevron-right" width="16" height="16"></use>
            </g>
        </g>
    </g>
    <g id="Arrow_2" filter="url(#newsSection_filter_1_2)">
        <g>
            <g id="Arrows/chevron left">
                <rect x="110" y="200" width="48" height="48" rx="4" class="secondaryBtnBgColor secondaryBtnBorderColor--stroke"/>
                <use class="secondaryBtnFontColor" transform="translate(125, 216)" href="#chevron-left" width="16" height="16"></use>
            </g>
        </g>
    </g>
</g>
<defs>
    <filter id="newsSection_filter_1_1" x="1286" y="196" width="56" height="56" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
        <feOffset/>
        <feGaussianBlur stdDeviation="2"/>
        <feComposite in2="hardAlpha" operator="out"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"/>
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2123_840782"/>
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2123_840782" result="shape"/>
    </filter>
    <filter id="newsSection_filter_1_2" x="106" y="196" width="56" height="56" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
        <feOffset/>
        <feGaussianBlur stdDeviation="2"/>
        <feComposite in2="hardAlpha" operator="out"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"/>
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2123_840782"/>
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2123_840782" result="shape"/>
    </filter>
    <linearGradient id="gradientSections" x1="161" y1="220.5" x2="-3.30512e-06" y2="220.5" gradientUnits="userSpaceOnUse">
        <stop stop-color="bgColor--stop" class="bgColor--stop"/>
        <stop offset="1" stop-color="bgColor--stop" class="bgColor--stop" stop-opacity="0"/>
    </linearGradient>
</defs>
`;